module.exports = __webpack_public_path__ + "media/images/home/light_bg-b3550e636068841be76cf661d25979e9.png";